const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const sendEcardSchema = (data) => {
  const schema = Joi.object({
    inmateID: Joi.number().min(1).required().messages({
      "number.base": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "number.min": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.only": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.required": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "string.empty": currentLang?.ValidationSchema?.Please_Choose_Inmate,
    }),

    ecardSubject: Joi.string().trim().required().messages({
      "any.required": currentLang?.ValidationSchema?.Please_enter_subject,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_subject,
    }),


    // file: Joi.string().trim().required().messages({
    //   "any.required": "Please select ecard.",
    //   "string.empty": "Please select ecard.",
    // }),


    // messageBody: Joi.string().trim().required().messages({
    //   "any.required": "Please enter description.",
    //   "string.empty": "Please enter description.",
    // }),
  }).unknown(true); // Allow unknown keys in the object (useful if you're validating only part of the data)

  return schema.validate(data, { abortEarly: false });
};

module.exports = sendEcardSchema;